import React, { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { baseUrl } from "../../Environments/environment";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import countries from "../../utils/countries";
import { apiClient } from "../../api";
import Select from "react-select";

const UpdateGuestModal = ({ guest, onClose }) => {
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { accessToken } = useAuth();
  const { selectedPropertyId } = useProperty();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  //const [countryCode, setCountryCode] = useState("");
  const [confirmationNumber, setConfirmationNumber] = useState("");
  const [arrivalDate, setArrivalDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState("");
  // const [draft, setDraft] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [reservationStatus, setReservationStatus] = useState("");
  // New state variables for registration details
  const [arrivalTime, setArrivalTime] = useState("");
  const [requireFields, setRequireFields] = useState({
    email: false,
    firstName: false,
    lastName: false,
  });
  const [selectedListings, setSelectedListings] = useState([]);
  const [reviewsJobFlow, setReviewsJobFlow] = useState([]);

  // Fetch guest data when modal opens
  useEffect(() => {
    if (guest) {
      setFirstName(guest.firstName || "");
      setLastName(guest.lastName || "");
      setEmail(guest.email || "");
      setPhoneNumber(guest.phoneNumber || "");
      setCountryCode(guest.countryCode || "");
      if (guest.countryCode) {
        // Find the country object from the countries list
        const country = countries.find((c) => c.code === guest.countryCode);
        if (country) {
          setSelectedCountry(country);
        }
      }
      if (guest.review?.listing?.length) {
        setSelectedListings(
          guest.review.listing.map((r) => {
            return {
              value: r.network,
              label: r.network.charAt(0).toUpperCase() + r.network.slice(1),
              ...r,
            };
          })
        );
      }
    }
    getRequireFieldSetting();
    fetchReviewJobs();
    console.log("guest", guest);
  }, [guest]);
  const getRequireFieldSetting = async () => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/requireFieldSetting/${selectedPropertyId}`
      );
      if (response.status === 200) {
        console.log(response);
        if (response?.data?.result?.setting) {
          const s = response?.data?.result?.setting;
          setRequireFields({
            email: s?.email ?? false,
            firstName: s?.firstName ?? false,
            lastName: s?.lastName ?? false,
          });
        }
      } else {
        console.error("API error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchReviewJobs = async () => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await apiClient.get(
        `${baseUrl}/reviews/jobs/${selectedPropertyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusCode === 200) {
        const rjs = (response.data.result.reviewJobs || []).map((r) => {
          return {
            value: r.network,
            label: r.network.charAt(0).toUpperCase() + r.network.slice(1),
          };
        });
        setReviewsJobFlow(rjs);
        console.log(reviewsJobFlow);
      }
    } catch (error) {
      console.error("Error fetching review jobs:", error);
    }
  };
  const cleanGuestData = (data) => {
    if (!data || Object.keys(data).length === 0) return {};

    return {
      firstName: data.firstName || null,
      lastName: data.lastName || null,
      email: data.email,
      listing: selectedListings.map((r) => {
        return { network: r.value, ...r };
      }),
      countryCode: !phoneNumber ? undefined : countryCode,
      phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
      ...(data.confirmationNumber && {
        confirmationNumber: data.confirmationNumber,
      }),
      //draft: !phoneNumber ? true : draft,
      checkIn: data.checkIn || null,
      ...(data.source &&
        data.source.trim().length > 0 && { source: data.source }),
    };
  };

  const handleUpdateGuest = async () => {
    setLoading(true); // Optional: set loading state if you have a loading indicator

    // Format check-in date and time
    const checkIn = `${arrivalDate}T${arrivalTime}Z`;

    const updatedGuestData = {
      guest: cleanGuestData({
        firstName,
        lastName,
        email,
        phoneNumber,
        countryCode,
        confirmationNumber,
        checkIn,
        source,
      }),
    };
    if (!updatedGuestData?.guest?.phoneNumber && !updatedGuestData?.guest?.email) {
      toast.error("Either Phone Number or Email is required!");
      setLoading(false);
      return;
    } else if (!updatedGuestData?.guest?.email && requireFields.email) {
      toast.error("Email is required !");
      setLoading(false);
      return;
    } else if (!updatedGuestData?.guest?.firstName && requireFields.firstName) {
      toast.error("FirstName is required !");
      setLoading(false);
      return;
    } else if (!updatedGuestData?.guest?.lastName && requireFields.lastName) {
      toast.error("LastName is required !");
      setLoading(false);
      return;
    }
    try {
      // Make the PATCH request to update guest information
      const response = await apiClient.patch(
        `${baseUrl}/guest/guestedit/${selectedPropertyId}/${guest._id}`,
        updatedGuestData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }

      if (response.status === 200) {
        toast.success("Guest updated successfully!");
        onClose();
      } else {
        toast.error("Failed to update guest. Please try again.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Error updating guest. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false); // Optional: reset loading state
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the dropdown and the trigger button
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm("");
      }
    };

    // Only add the event listener if the dropdown is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
    if (!isDropdownOpen) {
      // Reset search when opening
      setSearchTerm("");
      // Focus search input after opening
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  };

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setSearchTerm(""); // Clear search term on selection
    setIsDropdownOpen(false); // Close the dropdown
  };

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
        {loading && <LoadingSpinner />}
        <div className="bg-white rounded-lg shadow-xl w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl lg:w-[70vh] max-h-[95vh] overflow-y-auto p-4 sm:p-5 md:p-6 space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-7">
          {/* Headings  */}
          <div className="flex justify-between items-start">
            {/* Left Section with heading and guest info */}
            <div className="flex flex-col space-y-1 flex-1 min-w-0 pr-2">
              {/* Title and Guest Info */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <h2 className="text-base sm:text-lg font-semibold">
                  Update Review Request
                </h2>

                <div className="text-sm sm:text-lg text-gray-600 truncate">
                  {firstName && lastName && (
                    <span>{`${firstName} ${lastName}`}</span>
                  )}
                </div>
              </div>

              {/* Status and Button Section */}
            </div>

            {/* Close Button */}
            <div className="flex flex-col items-end flex-shrink-0">
              <button
                onClick={onClose}
                className="text-gray-600 hover:text-gray-900 p-1"
                aria-label="Close modal"
              >
                <AiOutlineClose size={20} className="sm:w-6 sm:h-6" />
              </button>
            </div>
          </div>

          {/* Update form */}
          <div className="w-full space-y-4 sm:space-y-5 pb-4 pt-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <div className="w-full sm:w-1/2">
                <label className="block text-xs sm:text-[13px] font-semibold mb-1 sm:mb-1.5 text-gray-700">
                  First Name
                </label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="block w-full border rounded-md border-gray-300 px-3 py-2 sm:py-1.5 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 text-sm sm:text-[15px] placeholder:text-gray-400 placeholder:font-light"
                />
              </div>
              <div className="w-full sm:w-1/2">
                <label className="block text-xs sm:text-[13px] font-semibold mb-1 sm:mb-1.5 text-gray-700">
                  Last Name
                </label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="block w-full border rounded-md border-gray-300 px-3 py-2 sm:py-1.5 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 text-sm sm:text-[15px] placeholder:text-gray-400 placeholder:font-light"
                />
              </div>
            </div>

            <div className="space-y-4 w-full">
              <div className="space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <div className="relative">
                  <div className="flex">
                    <div className="relative w-[100px] sm:w-[120px] flex-shrink-0">
                      <button
                        type="button"
                        onClick={toggleDropdown}
                        className="w-full h-full flex items-center justify-between px-2 sm:px-3 py-2 border border-gray-300 bg-white rounded-l-md text-xs sm:text-sm hover:bg-gray-50 transition-colors"
                      >
                        <span className="flex items-center gap-1 sm:gap-2 truncate">
                          {selectedCountry ? (
                            <>
                              <span className="truncate">{selectedCountry.code}</span>
                            </>
                          ) : (
                            "+1"
                          )}
                        </span>
                        <svg
                          className={`w-3 h-3 sm:w-4 sm:h-4 text-gray-400 transition-transform duration-200 flex-shrink-0 ${
                            isDropdownOpen ? "rotate-180" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </button>
                    </div>
                    <input
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Enter phone number"
                      className="flex-1 min-w-0 w-full rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-xs sm:text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
                    />
                  </div>

                  {/* Dropdown */}
                  {isDropdownOpen && (
                    <div
                      ref={dropdownRef}
                      className="absolute top-full left-0 mt-1 w-full sm:w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
                    >
                      <div className="p-2">
                        <input
                          ref={searchInputRef}
                          type="text"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder="Search country..."
                          className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs sm:text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
                        />
                      </div>
                      <div className="max-h-48 sm:max-h-60 overflow-y-auto">
                        {filteredCountries.map((country) => (
                          <div
                            key={country.code}
                            className="px-3 sm:px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 sm:gap-3 text-xs sm:text-sm"
                            onClick={() => handleCountrySelect(country)}
                          >
                            <span className="text-base sm:text-lg">{country.flag}</span>
                            <span className="text-gray-700 flex-1 truncate">
                              {country.name}
                            </span>
                            <span className="text-gray-500 flex-shrink-0">
                              {country.code}
                            </span>
                          </div>
                        ))}
                        {filteredCountries.length === 0 && (
                          <div className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-gray-500">
                            No countries found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full rounded-md border border-gray-300 
                   px-3 py-2 text-xs sm:text-sm text-gray-700 
                   focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                   placeholder:text-gray-400"
                />
              </div>
              <div className="text-xs sm:text-sm">
                <Select
                  isMulti
                  options={reviewsJobFlow}
                  value={selectedListings}
                  onChange={(selected) => setSelectedListings(selected)}
                  placeholder="Select platforms..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  menuShouldScrollIntoView={false}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      fontSize: '0.875rem',
                      minHeight: '38px',
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '0.875rem',
                    }),
                  }}
                  classNamePrefix="react-select"
                />
              </div>
            </div>
          </div>
          <div className="flex pt-4 w-full items-center justify-center">
            <div className="flex-shrink-0 w-full sm:w-auto">
              <button
                onClick={handleUpdateGuest}
                disabled={loading}
                className="w-full sm:w-auto px-4 py-2.5 sm:py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm sm:text-base"
              >
                {loading ? "Saving..." : "Save changes"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateGuestModal;
